export default __webpack_public_path__ + "40dba0a7ee09358e60d9befedbecb118.png";